/**
 * The authenticated shell's root classes, named so the one decision in them is
 * pinned by a test rather than rediscovered on a phone.
 *
 * `h-dvh`, not `h-screen`: 100vh is the phone's LARGE viewport — taller than
 * what is visible while a browser toolbar or the home indicator is in play —
 * and with `overflow-hidden` the excess clips whatever sits at the bottom of
 * the column: the bottom bar's labels ended up under the rounded corners.
 * The dynamic viewport height tracks what is actually visible.
 */
export const APP_SHELL_CLASS =
  'bg-accent text-foreground dark:bg-background dark:text-foreground relative flex h-dvh overflow-hidden';
